import { formatDate } from "@angular/common";
import { environment } from "src/environments/environment";

export class Consultants {
  private id: number;
  private gender: string;
  private first_name: string;
  private last_name: string;
  private email: string;
  private date_birth: Date;
  private phone_1: string;
  private phone_2: string;
  private cv_path: string;
  private daily_fee: string;
  private token: string;
  private date_create: Date;
  private date_update: Date;
  private is_delete: boolean;
  private consultantsProduits: any[];
  private consultantsExpertises: any[];
  private consultantsMissions: any[];
  private consultantsCountries: any[];

  constructor(consultantsModel: any) {
    this.id = consultantsModel.id;
    this.gender = consultantsModel.gender;
    this.first_name = consultantsModel.first_name;
    this.last_name = consultantsModel.last_name;
    this.email = consultantsModel.email;
    this.date_birth = consultantsModel.date_birth;
    this.phone_1 = consultantsModel.phone_1;
    this.phone_2 = consultantsModel.phone_2;
    this.cv_path = consultantsModel.cv_path;
    this.daily_fee = consultantsModel.daily_fee;
    this.token = consultantsModel.token;
    this.date_create = consultantsModel.date_create;
    this.date_update = consultantsModel.date_update;
    this.is_delete = consultantsModel.is_delete;
    this.consultantsProduits = consultantsModel.consultantsProduits;
    this.consultantsExpertises = consultantsModel.consultantsExpertises;
    this.consultantsMissions = consultantsModel.consultantsMissions;
    this.consultantsCountries = consultantsModel.consultantsCountries;
  }

  public getId(): number {
    return this.id;
  }

  public getName(): string {
    const name = this.first_name + ' ' + this.last_name;
    let username = '';

    if (name.length > 23) {
      for (let index = 0; index < 10; index++) {
        const element = name[index];
        username += element;
      }
      username += ' ...';
    } else {
      username = this.first_name + ' ' + this.last_name;
    }

    return username;
  }

  public getGender(): string {
    return this.gender;
  }

  public getFirstName(): string {
    return this.first_name;
  }

  public getLastName(): string {
    return this.last_name;
  }

  public getEmail(): string {
    return this.email;
  }

  public getDateBirth(): String {
    if (this.date_birth == null) {
      return '';
    } else {
      const date = new Date(this.date_birth);
      const formattedDate = formatDate(date, 'yyyy-MM-dd', 'EN');
      return formattedDate;
    }
  }

  public getPhone1(): string {
    return this.phone_1;
  }

  public getPhone2(): string {
    return this.phone_2;
  }

  public getCvPath(): string {
    return (this.cv_path != null && this.cv_path != '') ? environment.apiUrl + this.cv_path : this.cv_path;
  }

  public getDailyFee(): string {
    return this.daily_fee;
  }

  public getToken(): string {
    return this.token;
  }

  public getNbMission(): number {
    return (this.consultantsMissions) ? this.consultantsMissions.length : 0;
  }

  public getDateCreate(): Date {
    return this.date_create;
  }

  public getDateUpdate(): Date {
    return this.date_update;
  }

  public getIsDelete(): boolean {
    return this.is_delete;
  }

  public getConsultantsProduits(): any[] {
    return this.consultantsProduits;
  }

  public getConsultantsExpertises(): any[] {
    return this.consultantsExpertises;
  }

  public getConsultantsMissions(): any[] {
    return this.consultantsMissions;
  }

  public getConsultantsCountries(): any[] {
    return this.consultantsCountries;
  }
}